<div class="drawer-overlay" (click)="onCancel()">
    <div class="drawer" (click)="onWindowClick($event)">
        <div class="drawer-header">
            <h3>{{'COMMON.ADD_FILTER.PLURAL' | translate}}</h3>
        </div>
        <div class="drawer-body">
            <ul>
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('date')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.125 8.12435H16.875M6.45833 3.95768V2.29102M13.5417 3.95768V2.29102M5.625 16.8744H14.375C15.7557 16.8744 16.875 15.7551 16.875 14.3744V6.45768C16.875 5.07697 15.7557 3.95768 14.375 3.95768H5.625C4.24429 3.95768 3.125 5.07697 3.125 6.45768V14.3744C3.125 15.7551 4.24429 16.8744 5.625 16.8744Z" [attr.stroke]="openedFilters.includes('date') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('date')">
                                    {{'COMMON.DATE' | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('date')"
                            />
                        </div>
                        
                        <div *ngIf="openedFilters.includes('date')" class="date-filter-section">
                            <div class="filter-row">
                                <select [(ngModel)]="selectedDateTypeString" class="full-width" (change)="onDateTypeChange()">
                                    <option *ngFor="let type of dateTypes" [value]="type">{{ type | translate }}</option>
                                </select>
                            </div>

                            <div class="filter-row">
                                <button class="full-width"><span>{{'COMMON.DATE_FROM' | translate}}: </span><input type="date" [(ngModel)]="selectedDateFrom"></button>
                                

                                <button class="full-width"><span>{{'COMMON.DATE_TO' | translate}}: </span><input type="date" [(ngModel)]="selectedDateTo"></button>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                <div class="filter-item">
                    <div class="filter-header" (click)="toggleFilter('region')">
                        <div class="img-title-container">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0009 13.5417V16.875M10.0009 13.5417H5.03121C4.48967 13.5417 3.98189 13.2786 3.6696 12.8362L2.34607 10.9612C1.93933 10.3849 1.93933 9.61508 2.34607 9.03883L3.6696 7.16386C3.98189 6.72144 4.48967 6.45833 5.03121 6.45833H9.16758C9.62783 6.45833 10.0009 6.83143 10.0009 7.29167V13.5417ZM10.8342 3.125H14.9707C15.5122 3.125 16.02 3.38811 16.3323 3.83053L17.6558 5.70553C18.0626 6.28174 18.0626 7.05159 17.6558 7.62781L16.3323 9.50283C16.02 9.94525 15.5122 10.2083 14.9707 10.2083H10.8342C10.3741 10.2083 10.0009 9.83525 10.0009 9.375V3.95833C10.0009 3.4981 10.3741 3.125 10.8342 3.125Z" [attr.stroke]="openedFilters.includes('region') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="filter-title" [class.date-open]="openedFilters.includes('region')">
                                {{'COMMON.BU.SINGLE' | translate}} & {{'COMMON.UT.SINGLE' | translate}}
                            </span>
                        </div>
                        <img
                            src="../../../assets/icons/ng_v3/dropdown-icon.svg"
                            alt="Dropdown"
                            [class.open]="openedFilters.includes('region')"
                        />
                    </div>
                    <div *ngIf="openedFilters.includes('region')" class="filter-section">
                    <div class="region-area-container" *ngIf="!hasCimDataIntegration">
                        <div class="region-column">
                        <div class="search-row">
                            <input
                            type="text"
                            placeholder="Search by region"
                            [(ngModel)]="regionSearchText"
                            (ngModelChange)="updateAreas()"
                            />
                        </div>
                        <div class="region-list">
                            <div *ngFor="let region of filteredRegions" class="region-item">
                            <div
                                class="region-header"
                                [class.selected]="selectedRegion?.id === region.id"
                                (click)="selectRegion(region)"
                            >
                                <span>{{ region.name }}</span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="none" d="M6 12L10 8L6 4" stroke="currentColor" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div *ngIf="selectedRegion != null" class="area-column">
                        <div class="search-row">
                            <input
                            type="text"
                            placeholder="Search by district"
                            [(ngModel)]="districtSearchText"
                            (ngModelChange)="updateAreas()"
                            />
                        </div>
                        <div class="area-list">
                            <div *ngFor="let area of areas" class="area-item">
                            <input type="checkbox" [checked]="isAreaSelected({id: area.id, name: area.name})" (change)="onAreaSelect({id: area.id, name: area.name}, $event)"/>
                            <span>{{ area.name }}</span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="region-area-container" *ngIf="hasCimDataIntegration">
                        <div class="region-column">
                        <div class="search-row">
                            <input
                            type="text"
                            placeholder="Search by region"
                            [(ngModel)]="regionSearchText"
                            (ngModelChange)="updateSubGeographicalRegions()"
                            />
                        </div>
                        <div class="region-list">
                            <div *ngFor="let region of filteredGeographicalRegions" class="region-item">
                            <div
                                class="region-header"
                                [class.selected]="selectedGeographicalRegion?.id === region.id"
                                (click)="selectGeographicalRegion(region)"
                            >
                                <span>{{ region.name }}</span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="none" d="M6 12L10 8L6 4" stroke="currentColor" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div *ngIf="selectedGeographicalRegion != null" class="area-column">
                        <div class="search-row">
                            <input
                            type="text"
                            placeholder="Search by district"
                            [(ngModel)]="districtSearchText"
                            (ngModelChange)="updateSubGeographicalRegions()"
                            />
                        </div>
                        <div class="area-list">
                            <div *ngFor="let sub of subGeographicalRegions" class="area-item">
                            <input type="checkbox" [checked]="isSubGeoSelected({id: sub.id ?? 0, name: sub.name})" (change)="onSubGeoSelect({id: sub.id ?? 0, name: sub.name}, $event)"/>
                            <span>{{ sub.name }}</span>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </li>
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('user-type')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z" [attr.stroke]="openedFilters.includes('user-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>                                      
                                    <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z" [attr.stroke]="openedFilters.includes('user-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('user-type')">
                                    {{"COMMON.USER.TYPE.TITLE" | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('user-type')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('user-type')" class="user-type-filter-section">
                            <label *ngFor="let option of userTypes">
                                <input
                                    type="radio"
                                    name="userType"
                                    [value]="option.value"                                    
                                    [(ngModel)]="selectedUserType"
                                    (change)="onSelectUserType(option)"
                                />
                                <span class="option">{{ 'COMMON.USER.TYPE.'+option.label.toUpperCase() | translate }}</span>
                            </label>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="filter-item">

                        <div class="filter-header" (click)="toggleFilter('users')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z" [attr.stroke]="allUsers.length == 0 ? '#999' : openedFilters.includes('users') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>
                                    <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z" [attr.stroke]="allUsers.length == 0 ? '#999' : openedFilters.includes('users') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('users')">
                                    {{'COMMON.USER.PLURAL' | translate}}
                                </span>
                            </div>
                            <img 
                            src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                            alt="Dropdown" 
                            [class.open]="openedFilters.includes('users')"
                            />
                        </div>
                        <div *ngIf="allUsers.length > 0 && openedFilters.includes('users')" class="users-filter-section">
                            <input
                                type="text"
                                [(ngModel)]="searchUsersText"
                                placeholder="Search users..."
                                class="user-search-input"
                            />
                            <label *ngFor="let user of filteredUsers">
                                <input
                                type="checkbox"
                                (change)="onSelectUser(user, $event)"
                                [checked]="isUserSelected(user)"
                                />
                                <span class="option">{{ user.name }}</span>
                            </label>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('pole-type')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.49935 11.6257C4.46923 12.0466 2.29102 13.2115 2.29102 14.5827C2.29102 16.3086 5.74215 17.7077 9.99935 17.7077C14.2565 17.7077 17.7077 16.3086 17.7077 14.5827C17.7077 13.2115 15.5295 12.0466 12.4993 11.6257M9.99935 7.70768V14.3743M11.9142 3.08414C12.9722 4.14217 12.9722 5.85757 11.9142 6.91455C10.8563 7.97154 9.141 7.97258 8.08409 6.91455C7.02718 5.85653 7.02614 4.14113 8.08409 3.08414C9.14203 2.02716 10.8563 2.02612 11.9142 3.08414Z" [attr.stroke]="openedFilters.includes('pole-type') ? 'var(--primary-color)' : '#17171A'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('pole-type')">
                                    {{'COMMON.TABLE_HEADERS.POLE_TYPE' | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('pole-type')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('pole-type')" class="pole-type-filter-section">
                            <label *ngFor="let option of poleTypes">
                                <input
                                    type="radio"
                                    name="poleType"
                                    [value]="option.value"
                                    [(ngModel)]="selectedPoleType"
                                />
                                <span class="option">{{ 'MV_POLES.TYPE.'+option.label.toLocaleUpperCase() | translate }}</span>
                            </label>
                        </div>
                    </div>
                </li>
                <!-- <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('pole-condition')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.99935 14.3743V2.29102L14.9993 5.20768L9.99935 8.12435M7.49935 11.6253C4.46923 12.0463 2.29102 13.2112 2.29102 14.5823C2.29102 16.3082 5.74215 17.7073 9.99935 17.7073C14.2565 17.7073 17.7077 16.3082 17.7077 14.5823C17.7077 13.2112 15.5295 12.0463 12.4993 11.6253" [attr.stroke]="openedFilters.includes('pole-condition') ? 'var(--primary-color)' : '#17171A'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('pole-condition')">
                                    Pole Condition
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('pole-condition')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('pole-condition')" class="pole-condition-filter-section">
                            <label *ngFor="let option of poleConditions">
                                <input
                                    type="radio"
                                    name="poleCondition"
                                    [value]="option.value"
                                    [(ngModel)]="selectedPoleCondition"
                                />
                                <span class="option">{{ option.label }}</span>
                            </label>
                        </div>
                    </div>
                </li> -->
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('validation-status')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.29167 9.99917L9.09725 11.8742L12.7083 8.12417M3.125 10.8325V6.4459C3.125 5.4425 3.72492 4.53633 4.64863 4.14445L9.02367 2.28839C9.64767 2.02366 10.3523 2.02366 10.9763 2.28839L15.3513 4.14445C16.2751 4.53633 16.875 5.4425 16.875 6.4459V10.8325C16.875 14.6294 13.7969 17.7075 10 17.7075C6.20304 17.7075 3.125 14.6294 3.125 10.8325Z" [attr.stroke]="openedFilters.includes('validation-status') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('validation-status')">
                                    {{'COMMON.VALIDATION_STATUS' | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('validation-status')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('validation-status')" class="validation-status-filter-section">
                            <label *ngFor="let option of validationStatuses">
                                <input
                                    type="radio"
                                    name="validationStatus"
                                    [value]="option.value"
                                    [(ngModel)]="selectedValidationStatus"
                                />
                                <span class="option">{{ 'COMMON.ASSET_STATUS.'+option.label.toUpperCase()| translate }}</span>
                            </label>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="drawer-footer">
            <button class="cancel-btn" (click)="onCancel()">{{'COMMON.CANCEL' | translate }}</button>
            <button class="add-filter-btn" (click)="onAddFilter()">{{'COMMON.ADD_FILTER.SINGLE' | translate}}</button>
        </div>
    </div>
</div>